// پوسته Console: بدون انتخاب مستأجر و بدون داده مستأجر (IA §1)؛ منو بر پایه نقش‌های پلتفرم.
import AdminPanelSettingsOutlinedIcon from '@mui/icons-material/AdminPanelSettingsOutlined';
import { AccountMenu, usePlatformSession } from '@phoenix/auth';
import { useTranslation } from '@phoenix/i18n';
import { AppShell, resolveMenu, type Crumb } from '@phoenix/ui';
import { useEffect, useMemo } from 'react';
import { Outlet, useMatches } from 'react-router';
import { consoleMenu } from './navigation';

export function ConsoleLayout() {
  const { t } = useTranslation('shell');
  const { hasPlatformRole } = usePlatformSession();
  const matches = useMatches();

  const menu = useMemo(
    () => resolveMenu(consoleMenu, { can: () => false, featureEnabled: () => true, hasPlatformRole }),
    [hasPlatformRole],
  );
  const crumbs = useMemo(() => {
    const last = [...matches]
      .reverse()
      .find((match) => (match.handle as { crumbs?: Crumb[] } | undefined)?.crumbs);
    return (last?.handle as { crumbs?: Crumb[] } | undefined)?.crumbs ?? [];
  }, [matches]);

  useEffect(() => {
    document.title = t('shell:app.console_name');
  }, [t]);

  return (
    <AppShell
      appNameKey="shell:app.console_name"
      brand={<AdminPanelSettingsOutlinedIcon color="secondary" />}
      headerActions={<AccountMenu showTenants={false} />}
      menu={menu}
      breadcrumbs={crumbs}
    >
      <Outlet />
    </AppShell>
  );
}
